<template>
  <el-aside class="header" width="100px">
    <el-dialog
      v-loading="connect.loading"
      :title="connect.create ? 'Register' : 'Connect'"
      :visible.sync="connect.visible"
      width="80%">
      <el-form :model="connect.data" label-width="120px"
        @submit.native.prevent="handleConnect">
        <el-form-item label="Email" prop="email" :required="true">
          <el-input v-model="connect.data.email" type="email"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password" :required="true">
          <el-input v-model="connect.data.password" type="password"></el-input>
        </el-form-item>
        <template v-if="connect.create">
          <el-form-item label="Password confirmation" prop="password_confirm"
            :required="true" :rules="connect.confirmValidator">
            <el-input v-model="connect.data.password_confirm" type="password"></el-input>
          </el-form-item>
        </template>
        <el-form-item>
          <el-button native-type="submit">{{connect.create ? 'Register' : 'Connect'}}</el-button>
          <el-button @click="connect.visible = false">Cancel</el-button>
        </el-form-item>
        <a href="#" @click.prevent="connect.create = !connect.create">{{
        connect.create ? 'Connect' : 'Register'}}</a>
      </el-form>
    </el-dialog>
    <div class="header-logo ">
      <div class="box-logo flex align-center">
        <router-link :to="{ path: '/' }"><img class="image-logo" src="../assets/img/logo.svg" alt="logo" width="70"></router-link>
        <i class="menu-button el-icon-menu"
          :class="{'is-active': menu}"
          @click="$emit('update:menu', !menu)"></i>
      </div>
    </div>
    <div class="header-account align-right">
      <div class="user-manager" v-if="canListUsers">
        <router-link to="/users">
          <img src="../assets/img/icon-manager.png" class="avatar" alt="manager image">
        </router-link>
      </div>
      <el-dropdown trigger="click">
        <div class="el-dropdown-link">
          <img src="../assets/img/icon-user.png" class="avatar" alt="avatar">
          <!-- <button class="toggle-sidebar toggle-sidebar__right card-base card-shadow--small">
            <i class="el el-icon-arrow-down"></i>
          </button> -->
        </div>
        <el-dropdown-menu slot="dropdown" class="account-user"
          v-if="state.user">
          <span class="username">{{state.user.email}}</span>
          <el-dropdown-item command="/profile">
            <i class="el-icon-fa el-icon-fa-external-link"></i> <router-link to="/users/me">Profile</router-link>
          </el-dropdown-item>
          <el-dropdown-item command="/logout" >
            <i class="el-icon-fa el-icon-fa-flash"></i> <a href="#" v-if="state.user" @click="handleDisconnect">Logout</a>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-aside>
</template>

<script>
import State from '../stores/state.js'

export default {
  name: 'HeaderTop',
  inject: ['onerror'],
  props: {
    menu: Boolean,
  },
  data () {
    let confirmValidator = {
      validator: (rule, value, callback) => {
        let data = this.connect.data
        if (data.password !== data.password_confirm) {
          callback(new Error('confirmation is different than password'))
        } else callback()
      },
    }
    return {
      state: State.state,
      connect: {
        loading: false,
        visible: false,
        data: {
          email: 'test@olli-ai.com',
          password: 'test',
          password_confirm: '',
        },
        create: false,
        confirmValidator,
      },
    }
  },
  computed: {
    canListUsers () {
      return this.state.user && this.state.user.role === 'admin' &&
        this.state.user.authorizations.user !== 'forbidden'
    },
  },
  watch: {
    'state.error' (error) {
      if (!error) return
      else if (error.status === 401) {
        this.$message({
          message: 'Not connected',
          type: 'error',
        })
        this.$router.push({ name: 'login', query: { next: this.$route.fullPath } })
        this.connect.visible = true
      }
    },
    'connect.visible' () {
      this.connect.data.password = 'test'
      this.connect.data.password_confirm = ''
      this.connect.create = false
    },
    'state.user' (user) {
      if (user) this.connect.visible = false
    },
  },
  methods: {
    handleConnect () {
      this.connect.loading = true
      if (this.connect.create) {
        State.createUser({
          email: this.connect.data.email,
          password: this.connect.data.password,
          role: 'client',
          infos: {},
          authorizations: {},
        }).then(() => {
          this.$message({
            message: 'user created, you can login',
            type: 'success',
          })
          this.connect.create = false
        }, error => this.onerror(error, 'Error on connection'))
          .finally(() => { this.connect.loading = false })
      } else {
        State.connect({
          email: this.connect.data.email,
          password: this.connect.data.password,
        }).then(user => {
          this.$message({
            message: 'Connected on ' + user.email,
            type: 'success',
          })
          this.connect.visible = false
        }, error => this.onerror(error, 'Error on connection'))
          .finally(() => { this.connect.loading = false })
      }
    },
    handleDisconnect () {
      State.disconnect().then(() => {
        this.$message({
          message: 'Disconnected',
          type: 'success',
        })
        this.$router.push({ name: 'login' })
      }, this.onerror)
    },
  },
}
</script>

<style lang="scss">
  @import "../element-variables.scss";
  @import "../variables.scss";

  button:focus {
    outline: none;
  }
  .header.el-aside {
    background-color: #fff;
    padding: 10px 15px;
    height: 100vh;
    z-index: $overlay-z-index;
    box-shadow: 3px 0 5px -2px rgba(175, 177, 179, 0.8);

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .header-logo  {
      margin-top: 17px;
    }
    .header-account {
      .user-manager {
        margin-bottom: 20px;
      }
      .el-dropdown-link  {
        button {
          background: transparent;
          border: 0;
        }
      }
      img.avatar {
        margin-right: 8px;
      }
    }

  }
    .align-right{
      text-align: right;
    }
  .el-popper[x-placement^="top"] {
    z-index: 9991 !important;
  }
  .el-dropdown-menu.account-user {
    padding: 20px 20px 10px;
    left: 20px !important;
    span {
      font-weight: bold;
      display: inline-block;
      border-bottom: 1px solid #ddd;
      width: 100%;
      margin-bottom: 15px;
      padding-bottom: 10px;
    }
    .el-dropdown-menu__item {
      padding: 0;
      line-height: 28px;
    }
    a {
      color: $--color-text-regular;
      /* font-weight: bold; */
      text-decoration: none;
    }
  }

  .menu-button {
    display: none !important;
    font-size: 60px;
    text-align: center;
    margin-top: 20px;
    color: #95a4b4;
    transition: transform .3s, -webkit-transform .3s;
    &.is-active {
      transform: rotate(90deg);
    }
  }
  @media (max-width: 1100px) {
    .menu-button { display: block  !important }
  }
</style>
